import { Routes } from '@angular/router';

import { InvalidLinkPageComponent } from './invalid-link-page/invalid-link-page.component';
import { NotAuthorizedPageComponent } from './not-authorized-page/not-authorized-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('@mitsubishi/dashboard/feature-shell').then(m => m.DashboardFeatureShellModule),
  },
  {
    path: 'dashboard',
    component: InvalidLinkPageComponent,
  },
  {
    path: 'project',
    loadChildren: () => import('@mitsubishi/project/feature-shell').then(m => m.ProjectFeatureShellModule),
  },
  {
    path: 'company',
    loadChildren: () => import('@mitsubishi/company/feature-shell').then(m => m.CompanyFeatureShellModule),
  },
  {
    path: 'search',
    loadChildren: () => import('@mitsubishi/search/feature-shell').then(m => m.SearchFeatureShellModule),
  },
  {
    path: 'selection',
    loadChildren: () => import('@mitsubishi/selections/feature-shell').then(m => m.SelectionsFeatureShellModule),
  },
  {
    path: 'energy-analysis',
    loadChildren: () =>
      import('@mitsubishi/energy-analyses/feature-shell').then(m => m.EnergyAnalysesFeatureShellModule),
  },
  {
    path: 'news',
    loadChildren: () => import('@mitsubishi/news/feature-shell').then(m => m.NewsFeatureShellModule),
  },
  {
    path: 'library',
    loadChildren: () => import('@mitsubishi/library/feature-shell').then(m => m.LibraryFeatureShellModule),
  },
  {
    path: 'ticket',
    loadChildren: () => import('@mitsubishi/tickets/feature-shell').then(m => m.TicketsFeatureShellModule),
  },
  {
    path: 'pricing-list',
    loadChildren: () => import('@mitsubishi/pricing-list/feature-shell').then(m => m.PRICE_LIST_ROUTES),
  },
  {
    path: 'public',
    loadChildren: () => import('@mitsubishi/public/offer').then(m => m.PublicOfferModule),
  },
  { path: 'not-authorized', component: NotAuthorizedPageComponent },
  { path: '**', component: PageNotFoundComponent },
];
